<template>
  <div>
    <PageHeader :navigation="navigation" :alternate-languages="alternateUrls" />
    <CompactTransferSearchForm
      :default-country-from="corridor.countryFrom.iso"
      :default-country-to="corridor.countryTo.iso"
      :default-currency-from="corridor.currencyFrom.iso"
      :default-currency-to="corridor.currencyTo.iso"
      :default-amount="corridor.amount || corridor.defaultAmount"
    />
    <TransferComparison
      class="container mb-20"
      :corridor="corridor"
      :metadata="page"
      :landing-mode="false"
      :historical-data="historicalData"
    />
    <PageBody :body="body" :page="page" no-hero />
    <LazyPageFooter v-if="footer" :footer="footer" />
    <ClientOnly>
      <LazyBookmarkPrompt />
    </ClientOnly>
  </div>
</template>

<script lang="ts" setup>
import loadPageData from './async-data'

const { navigation, footer, body, page, corridor, alternateUrls, historicalData } =
  await loadPageData()

const pageMeta = computed(() => ({
  ...page,
  noIndex: true,
  title: `${corridor.amount} ${corridor.currencyFrom.iso} - ${corridor.currencyTo.iso} | Monito`,
}))
usePageMeta(pageMeta.value)
</script>
